import React from 'react';

import { RecursiveShortcodeProps } from './Shortcode';

const Sup = ({ RecursiveShortcode, elements, against, ...rest }: RecursiveShortcodeProps) => (
  <span
    style={{
      verticalAlign: 'super',
      fontSize: '0.8em',
    }}
  >
    {/* @ts-ignore: error when upgrading to @ux/config */}
    <RecursiveShortcode elements={elements} against={against} {...rest} />
  </span>
);

Sup.displayName = 'Bold';

export default Sup;
